import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { setRequireCloseModal } from '../../../../slices/user/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import RolesSelect from '../../../../Components/General/Selects/RolesSelect';
import { addNewPayment, updatePayment } from '../../../../slices/thunks';

const PaymentForm = ({
	dataPayment,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();

	const [selectedVisibility, setselectedVisibility] = useState(null);

	function handleSelectVisibility(selectedVisibility) {
		setselectedVisibility(selectedVisibility);
	}

	const selectorPayment = createSelector(
		state => state.Payments,
		user => ({
			isAdding: user.isAdding,
			isAdded: user.isAdded,
			isUpdating: user.isUpdating,
			isUpdated: user.isUpdated,
			isLoadingList: user.isLoadingList,
			requireCloseModal: user.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorPayment);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			username: (dataPayment && dataPayment.username) || '',
			email: (dataPayment && dataPayment.email) || '',
			first_name: (dataPayment && dataPayment.first_name) || '',
			last_name: (dataPayment && dataPayment.last_name) || '',
			disabled: (dataPayment && dataPayment.disabled) || false,
			role: (dataPayment && dataPayment.role) || '',
			password: '',
			active_directory: false,
		},
		validationSchema: Yup.object({
			username: Yup.string().required('Campo requerido'),
			email: Yup.string()
				.email(' El email no es válido')
				.required('Campo requerido'),
			first_name: Yup.string().required('Campo requerido'),
			last_name: Yup.string().required('Campo requerido'),
			password: isEdit
				? Yup.string()
				: Yup.string().required('Campo requerido'),
			role: Yup.string().required('Campo requerido'),
			disabled: Yup.boolean(),
		}),
		onSubmit: values => {
			if (isEdit) {
				// if there is no change in the password, then don't send it
				const updatedPayment = {
					username: values.username,
					email: values.email,
					first_name: values.first_name,
					last_name: values.last_name,
					full_name: `${values.first_name} ${values.last_name}`,
					disabled: values.disabled,
					role: values.role,
					establishment_assignation_ids: [],
					active_directory: values.active_directory,
					...(values.password === '' ? {} : { password: values.password }),
				};
				dispatch(
					updatePayment({ username: dataPayment.username, user: updatedPayment })
				);
			} else {
				const newPayment = {
					username: values.username,
					email: values.email,
					first_name: values.first_name,
					last_name: values.last_name,
					full_name: `${values.first_name} ${values.last_name}`,
					disabled: false,
					password: values.password,
					role: values.role,
					establishment_assignation_ids: [],
					active_directory: values.active_directory,
				};

				dispatch(addNewPayment(newPayment));
			}
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>
						<Row className='g-3'>
							<Col lg={3}>
								<Label for='username-field' className='form-label'>
									Nombre usuario
								</Label>
								<Input
									name='username'
									id='username-field'
									className='form-control'
									placeholder='Ingrese el Nombre de Usuario'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.username || ''}
									invalid={
										validation.touched.username &&
										validation.errors.username
											? true
											: false
									}
								/>
								{validation.touched.username &&
								validation.errors.username ? (
									<FormFeedback type='invalid'>
										{validation.errors.username}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={6}>
								<Label for='email-field' className='form-label'>
									E-Mail
								</Label>
								<Input
									name='email'
									id='email-field'
									className='form-control'
									placeholder='Ingrese el email'
									type='email'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.email || ''}
									invalid={
										validation.touched.email &&
										validation.errors.email
											? true
											: false
									}
								/>
								{validation.touched.email && validation.errors.email ? (
									<FormFeedback type='invalid'>
										{validation.errors.email}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={3}>
								<Label for='first_name-field' className='form-label'>
									Nombre
								</Label>
								<Input
									name='first_name'
									id='first_name-field'
									className='form-control'
									placeholder='Ingrese el Nombre'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.first_name || ''}
									invalid={
										validation.touched.first_name &&
										validation.errors.first_name
											? true
											: false
									}
								/>
								{validation.touched.first_name &&
								validation.errors.first_name ? (
									<FormFeedback type='invalid'>
										{validation.errors.first_name}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={3}>
								<Label for='last_name-field' className='form-label'>
									Apellido
								</Label>
								<Input
									name='last_name'
									id='last_name-field'
									className='form-control'
									placeholder='Ingrese el Apellido'
									type='text'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.last_name || ''}
									invalid={
										validation.touched.last_name &&
										validation.errors.last_name
											? true
											: false
									}
								/>
								{validation.touched.last_name &&
								validation.errors.last_name ? (
									<FormFeedback type='invalid'>
										{validation.errors.last_name}
									</FormFeedback>
								) : null}
							</Col>
							<Col lg={3}>
								<Label for='password-field' className='form-label'>
									Contraseña
								</Label>
								<Input
									name='password'
									id='password-field'
									className='form-control'
									placeholder='Ingrese la contraseña'
									type='password'
									validate={{ required: { value: true } }}
									onChange={validation.handleChange}
									onBlur={validation.handleBlur}
									value={validation.values.password || ''}
									invalid={
										validation.touched.password &&
										validation.errors.password
											? true
											: false
									}
								/>
								{validation.touched.password &&
								validation.errors.password ? (
									<FormFeedback type='invalid'>
										{validation.errors.password}
									</FormFeedback>
								) : null}
							</Col>
							{isEdit && (
								<Col lg={3}>
									<FormGroup className='d-flex align-items-center'>
										<Label
											for='disabled-field'
											className='form-label'
										>
											<Input
												id='disabled-field'
												name='disabled'
												type='checkbox'
												validate={{ required: { value: true } }}
												onChange={validation.handleChange}
												onBlur={validation.handleBlur}
												value={validation.values.disabled || ''}
												invalid={
													validation.touched.disabled &&
													validation.errors.disabled
														? true
														: false
												}
											/>
											¿Usuario desactivado?
										</Label>
										{validation.touched.disabled &&
										validation.errors.disabled ? (
											<FormFeedback type='invalid'>
												{validation.errors.disabled}
											</FormFeedback>
										) : null}
									</FormGroup>
								</Col>
							)}
							<Col lg={3}>
								<FormGroup className='d-flex align-items-center'>
									<Label
										for='active_directory-field'
										className='form-label'
									>
										<Input
											id='active_directory-field'
											name='active_directory'
											type='checkbox'
											validate={{ required: { value: true } }}
											onChange={validation.handleChange}
											onBlur={validation.handleBlur}
											value={
												validation.values.active_directory || ''
											}
											invalid={
												validation.touched.active_directory &&
												validation.errors.active_directory
													? true
													: false
											}
										/>
										¿Usuario de Active Directory?
									</Label>
									{validation.touched.active_directory &&
									validation.errors.active_directory ? (
										<FormFeedback type='invalid'>
											{validation.errors.active_directory}
										</FormFeedback>
									) : null}
								</FormGroup>
							</Col>
						</Row>
					</TabPane>
					<TabPane tabId='2'>
						<Row className='g-3'>
							<Col lg={3}>
								<RolesSelect
									value={{ _id: validation.values.role || '' }}
									invalid={
										validation.touched.role && validation.errors.role
											? true
											: false
									}
									error={validation.errors.role}
									onSelect={value =>
										validation.setFieldValue('role', value.item?._id)
									}
								/>
							</Col>
						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className='label-icon'><Spinner size='sm' /></i>
						) : (
							<i className='ri-save-3-line label-icon'></i>
						)}
						{isEdit ? 'Actualizar Payment' : 'Agregar Payment'}
					</button>
				</div>
			</div>
		</Form>
	);
};

export default PaymentForm;
